

















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";

@Component
export default class LinkWorkshopDialog extends Vue {
  @Prop() info!: any;
  private dialog: boolean;
  private loadingData: boolean;
  private nuovoLink: string;

  constructor() {
    super();
    this.dialog = false;
    this.loadingData = true;
    this.nuovoLink = "";
  }

  close() {
    this.dialog = false;
    this.nuovoLink = "";
  }

  save() {
    // if (this.nuovoLink !== "") {
    //     console.log('')
    // } else {
    //   bus.$emit("errorOperation", "Inserire un link");
    // }
  }
}
